import React, { useState } from "react";
import Header from "../components/Header";
import GamesTab from "../components/admin/GamesTab";
import ProductsTab from "../components/admin/ProductsTab";
import PaymentsTab from "../components/admin/PaymentsTab";
import StaffTab from "../components/admin/StaffTab";
import SupplierAccessTab from "../components/admin/SupplierAccessTab";
import CurrencyTab from "../components/admin/CurrencyTab";
import SoundsTab from "../components/admin/SoundsTab";
import MaintenanceTab from "../components/admin/MaintenanceTab";
import SupplierMonitorPanel from "../components/SupplierMonitorPanel";
import TelegramTab from "../components/admin/TelegramTab";
import { Gamepad2, Package, CreditCard, Users, Truck, DollarSign, Volume2, Wrench, Contact, Send } from "lucide-react";

const TABS = [
  { key: "games", label: "Game & Server", icon: Gamepad2, Comp: GamesTab },
  { key: "products", label: "Produk", icon: Package, Comp: ProductsTab },
  { key: "payments", label: "Metode Pembayaran", icon: CreditCard, Comp: PaymentsTab },
  { key: "currency", label: "Kurs $ / IDR", icon: DollarSign, Comp: CurrencyTab },
  { key: "sounds", label: "Bunyi Notifikasi", icon: Volume2, Comp: SoundsTab },
  { key: "maintenance", label: "Maintenance & Backup", icon: Wrench, Comp: MaintenanceTab },
  { key: "staff", label: "Akun Staff", icon: Users, Comp: StaffTab },
  { key: "suppliers", label: "Akses Supplier", icon: Truck, Comp: SupplierAccessTab },
  { key: "supplier-monitor", label: "Monitoring Supplier", icon: Contact, Comp: SupplierMonitorPanel },
  { key: "telegram", label: "Settings → Telegram", icon: Send, Comp: TelegramTab },
];

export default function Admin() {
  const [tab, setTab] = useState("games");
  const Active = TABS.find((x) => x.key === tab).Comp;

  return (
    <div className="min-h-screen bg-[#101114]">
      <Header />
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-10">
        <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#D4AF37] mb-2">OWNER</div>
        <h1 className="text-3xl font-bold text-[#F5F3ED] mb-8" style={{ fontFamily: "'Playfair Display', serif" }}>Panel Kelola</h1>
        <div className="flex gap-1 flex-wrap mb-8 border-b border-[#35353B]">
          {TABS.map(({ key, label, icon: Icon }) => (
            <button key={key} data-testid={`admin-tab-${key}`} onClick={() => setTab(key)}
              className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${tab === key ? "border-[#D4AF37] text-[#D4AF37]" : "border-transparent text-[#A8A8AD] hover:text-[#F5F3ED]"}`}>
              <Icon size={15} /> {label}
            </button>
          ))}
        </div>
        <div className="fade-in" key={tab}><Active /></div>
      </div>
    </div>
  );
}
